import { mapState, mapGetters, mapMutations } from "vuex";
import CashEditor from "@/views/Finance/widgets/CashEditor.vue";

export default {
	components: { CashEditor },
	data() {
		return {
			batchOps: [
				{
					key: "confirm",
					name: "批量审核",
				},
			],
			filterConfirmed: { field: "has_confirm", value: null },
			cashTableFieldsExpand: [
				{
					name: "desc",
					sortable: false
				},
				{
					name: "primary_img"
				}
			],
			cashSumFields: [
				{
					name: "count",
					title: "数量(笔)"
				},
				{
					name: "sum_total_price",
					title: "总价"
				},
				{
					name: "sum_gross_profit",
					title: "总利润"
				}
			],
			creditSumFields: [
				{
					name: "count",
					title: "数量(笔)"
				},
				{
					name: "sum_total_get",
					title: "总获得"
				},
				{
					name: "sum_total_cost",
					title: "总使用"
				}
			],
			balanceSumFields: [
				{
					name: "count",
					title: "数量(笔)"
				},
				{
					name: "sum_total_get",
					title: "总充值"
				},
				{
					name: "sum_total_cost",
					title: "总使用"
				}
			]
			
		};
	},
	computed: {
		...mapState(["userPrivilegeMapping"])
	},
	mounted() {},
	watch: {
		"filterConfirmed.value": {
			handler(newVal) {
				let val = this.filterConfirmed;
				if (val.value != null && val.value !== "") {
					this.$set(this.kvFilter, val.field, { k: val.field, t: "int", v: val.value });
				} else {
					this.$delete(this.kvFilter, val.field);
				}
			},
			immediate: true
		}
	},
	methods: {
		_handleBatch_confirm(ref,checks) {
				
				const data = this.$refs[ref].tableData.filter((v, k) => {
					return checks[k];
				});
				
				this.$confirm("确认已经核对这些金流？", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning"
				}).then(() => {
					this.$axios
						.post(`/cashflow/do_batch_confirm_cashflow/`, {
							recordIds:data.map(val => {
								return val._id;
						})})
						.then(json => {
							this.loadings.main = false;
							this.$message.success("成功");
							this.refreshTable("listTable");
						})
						.catch(json => {
							this.loadings.main = false;
							this.$message.error(json.data.msg);
						});
				});
		},
		handleBatch_confirmCashflow(checks) {
			const ref = 'cashflowTable';
			this._handleBatch_confirm(ref,checks);
		},
		handleBatch_confirm(checks){
			const ref = 'listTable';
			this._handleBatch_confirm(ref,checks);
		},
		handleBatch_edit(checks){
			//TODO
		},
		goCashflowRelate(row) {
			debugger;
			let id = "";
			if (row.order && row.order._id) {
				id = row.order._id;
				const { href } = this.$router.resolve({
					name: "Order-Info",
					params: {
						id: id,
						tab: "info"
					}
				});
				window.open(href, "_blank");
			} else if  (row.transaction && row.transaction._id) {
				id = row.transaction._id;
				const { href } = this.$router.resolve({
					name: "Tx-Info",
					params: {
						id: id,
						tab: "info"
					}
				});
				window.open(href, "_blank");
			} else if  (row.charge && row.charge._id) {
				id = row.charge._id;
				const { href } = this.$router.resolve({
					name: "Charge-Info",
					params: {
						id: id,
						tab: "info"
					}
				});
				window.open(href, "_blank");
			} 
			
		},
		doHasConfirm(id, tableRef = 'listTable') {
			this.$confirm("确认已经核对本金流？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			}).then(() => {
				this.$axios
					.post(`/cashflow/do_confirm_cashflow/${id}`, {})
					.then(json => {
						this.loadings.main = false;
						this.$message.success("成功");
						this.refreshTable(tableRef);
					})
					.catch(json => {
						this.loadings.main = false;
						this.$message.error(json.data.msg);
					});
			});
		}
	}
};
